import { Button, Form, notification, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import { addNewFeature, editFeature, getFeatureByID } from "../action";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";
import { useParams } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

type Props = {
  fetchData: () => void;
};

interface FormValues {
  feature: {
    en: string;
    ar: string;
    fr: string;
  };
}

const EditFeature: React.FC<Props> = ({ fetchData }) => {
  const { id } = useParams();

  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const fetchItem = async () => {
    setIsLoading(true);
    const ft = await getFeatureByID(id!);
    form.setFieldsValue({
      feature: {
        en: ft?.Feature.En,
        ar: ft?.Feature.Ar,
        fr: ft?.Feature.Fr,
      },
    });
    setIsLoading(false);
  };

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await editFeature(id!, formValues.feature);

      if (data) {
        fetchData();
        api.success({
          message: "Feature edited successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to edit feature",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchItem();
  }, [id]);

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="feature" label="Feature" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this feature?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<FaEdit />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Editing Feature..." : "Edit Feature"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default EditFeature;
